import React, { useEffect, useState } from 'react';
import { Font, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import { orange } from '@mui/material/colors';

Font.register({
    family: 'Ubuntu',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
            fontWeight: 'normal',
            fontStyle: 'italic',
        },
    ],
});
const imagePath = "https://sms.cooledsys.com/studentAmbitionPath.jpg";

const StudentAmbitionCard = ({ myAmbitionCard }) => {
    const [myAmbition, setMyAmbition] = useState('');
    const [lstSkillsNeeded, setLstSkillsNeeded] = useState([]);
    const [achieveAmitionByDt, setAchieveAmitionByDt] = useState('');
    const [lstFocusSubjects, setLstFocusSubjects] = useState([]);
    const [studyHabits, setStudyHabits] = useState([]);
    const [takeGuidanceFrom, setTakeGuidanceFrom] = useState('');
    const [helpMeBy, setHelpMeBy] = useState('');
    const [learnNew, setLearnNew] = useState('');
    const [iWillFeel, setIWillFeel] = useState('');
    const [myParentsWillFeel, setMyParentsWillFeel] = useState('');

    
    useEffect(() => {
        setMyAmbition(myAmbitionCard?.myAmbition || '');
        setLstSkillsNeeded(myAmbitionCard?.lstSkillsNeeded || []);
        setAchieveAmitionByDt(myAmbitionCard?.achieveAmitionByDt || '');
        setLstFocusSubjects(myAmbitionCard?.lstFocusSubjects || []);
        setStudyHabits(myAmbitionCard?.studyHabits || []);
        setTakeGuidanceFrom(myAmbitionCard?.iWill?.takeGuidanceFrom || '');
        setHelpMeBy(myAmbitionCard?.iWill?.helpMeBy || '');
        setLearnNew(myAmbitionCard?.iWill?.learnNew || '');
        setIWillFeel(myAmbitionCard?.iWill?.iWillFeel || '');
        setMyParentsWillFeel(myAmbitionCard?.iWill?.myParentsWillFeel || '');

    }, [myAmbitionCard]);



    return (
        <View style={[styles.container]}>
            <View style={[styles.header]}>
                <View style={[styles.headerRow]}>
                </View>
                <View style={[styles.headerRow]}>
                    <Text style={[styles.textHeading, { color: 'darkorange' }]}>Part A (3)</Text>
                </View>
                <View style={[styles.headerRow]}>
                    <Text style={[styles.textHeading, { color: 'black' }]}>My Ambition Card</Text>
                </View>
            </View>
            <View style={[styles.section]}>
                <View style={[styles.ambitionDescSection]}>
                    <View style={[styles.ambitionLabelSection]}>
                        <Text style={[styles.textRightLabel, { color: 'black' }]}>{"My ambition is  "}</Text>
                    </View>
                    <View style={styles.ambitionTextSection}>
                        <Text style={styles.textAmbition}>{myAmbition}</Text>
                    </View>
                </View>
                <View style={[styles.imageSection]}>
                    < View style={styles.imageContainer}>
                        <Image src={imagePath} style={styles.backgroundImage} />
                        <View style={styles.overlayAchieveAmitionBy}>
                            <Text style={styles.textSkillsNeeded}>I will achieve my ambition by</Text>
                            <Text style={styles.skillText}>{achieveAmitionByDt}</Text>
                        </View>
                        <View style={styles.overlaySkillText}>
                            <Text style={styles.textSkillsNeeded}>5 skills I need to achieve my ambition</Text>
                            {lstSkillsNeeded.map((skill, index) => (
                                <Text key={index} style={styles.skillText}>{skill}</Text>
                            ))}
                        </View>
                        <View style={styles.overlayFocusSubjects}>
                            <Text style={styles.textSkillsNeeded}>Subjects I need to focus on</Text>
                            {lstFocusSubjects.map((subject, index) => (
                                <Text key={index} style={styles.skillText}>{subject}</Text>
                            ))}
                        </View>
                        <View style={styles.overlayStudyHabits}>
                            <Text style={styles.textSkillsNeeded}>To achieve my ambition, I need my study habits to be</Text>
                            {studyHabits.map((habit, index) => (
                                <Text key={index} style={styles.skillText}>{habit}</Text>
                            ))}
                        </View>
                    </View>
                </View>
            </View>
            <View style={[styles.formSection]}>
                <View style={[styles.rowDesc]}>
                    <Text style={styles.labelForm}>I will...</Text>
                </View>
                <View style={[styles.formRows]}>
                    <View style={[styles.rowText]}>
                        <Text style={styles.textLeft}>I will take guidance from <Text style={{ textDecoration: "underline" }}>{takeGuidanceFrom}</Text> to achieve my ambition.</Text>
                    </View>
                    <View style={[styles.rowText]}>
                        <Text style={styles.textLeft}>I think this person will help me by <Text style={{ textDecoration: "underline" }}>{helpMeBy}</Text> .</Text>
                    </View>
                    <View style={[styles.rowText]}>
                        <Text style={styles.textLeft}>I will learn new <Text style={{ textDecoration: "underline" }}>{learnNew}</Text> .</Text>
                    </View>
                    <View style={[styles.rowText]}>
                        <Text style={styles.textLeft}>I will feel <Text style={{ textDecoration: "underline" }}>{iWillFeel}</Text> when I achieve my ambition.</Text>
                    </View>
                    <View style={[styles.rowText]}>
                        <Text style={styles.textLeft}>My parents will feel <Text style={{ textDecoration: "underline" }}>{myParentsWillFeel}</Text> when I achieve my ambition.</Text>
                    </View>
                </View>
            </View>
            <View style={styles.divider} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "column",
    },
    header: {
        flex: 3,
        flexDirection: "column",
    },
    headerRow: {
        flex: 1,
        justifyContent: "center",
        // border: '1px solid blue',
    },
    textHeading: {
        // marginTop: 100,
        fontSize: 16,
        fontWeight: "bold",
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#e36c0a',
        fontFamily: 'Helvetica-Bold',
        // borderRadius: 6,
        padding: 10,
        paddingTop: 30
    },
    textSkillsNeeded: {
        fontSize: 14,
        textAlign: 'center',
        marginBottom: 5,
    },
    section: {
        flex: 13,
        flexDirection: "column",
        margin: 10,
    },
    formSection: {
        flex: 7,
        flexDirection: "column",
        marginHorizontal: 30,
    },
    rowDesc: {
        height: 30,
        backgroundColor: "#EBC9A8",
        justifyContent: "center",
        alignContent: "center"
    },
    formRows: {
        flexDirection: "column",
    },
    rowText: {
        // height: 20,
        marginTop:10,
        justifyContent: 'center',
    },
    ambitionDescSection: {
        height: "50px",
        flexDirection: "row",
        paddingHorizontal: "5px",
        // border: '1px solid darkorange',
    },
    ambitionLabelSection: {
        flex: 1,
        // paddingRight: "5px",
    },
    ambitionTextSection: {
        flex: 3,
        paddingHorizontal: 10,
        paddingTop: 4,
        // borderBottomWidth: 1,  // Underline the entire text area
        // borderBottomColor: 'black',
        // paddingBottom: 2, 
    },
    imageSection: {
        width: "100%",
        // flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        // border: '1px solid blue',
    },
    imageContainer: {
        width: "500px",
        height: "400px",
        // border: '1px solid green',
        position: 'relative',
    },
    backgroundImage: {
        position: 'absolute',
        width: "500px",
        height: "400px",
    },
    overlaySkillText: {
        position: 'absolute',
        marginTop: 73,
        height: 174,
        width: 161,
        padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
    },
    overlayAchieveAmitionBy: {
        position: 'absolute',
        marginTop: 55,
        marginLeft: 265,
        height: 70,
        width: 218,
        padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
    },
    overlayFocusSubjects: {
        position: 'absolute',
        marginTop: 196,
        marginLeft: 360,
        height: 130,
        width: 140,
        padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
    },
    overlayStudyHabits: {
        position: 'absolute',
        marginTop: 276,
        marginLeft: 46,
        height: 122,
        width: 196,
        padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
    },
    skillText: {
        fontSize: 11,
        textAlign: 'center',
        marginTop: 5,
        color:"#8B4513",
    },
    labelForm: {
        fontSize: 16,
        textAlign: 'center',
    },
    textLeft: {
        fontSize: 13,
        textAlign: 'left',
    },
    textRightLabel: {
        fontSize: 16,
        textAlign: 'right',
        marginVertical: 2,
    },
    textAmbition: {
        fontSize: 14,
        fontFamily: 'Ubuntu',
        textAlign: "left",
        textDecoration: "underline",
        // textDecorationColor:"black",
    },
    divider: {
        backgroundColor: 'darkorange',
        width: '90%',
        height: 1,
        position: 'absolute',
        bottom: 30,
        left: '5%',
    }
});

export default StudentAmbitionCard;